import waterImg from "../../images/faq.jpg";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import img1 from "../../images/faq1.jpg";
import img2 from "../../images/faq2.jpg";
const FaqHeroSection = () => {
  return (
    <>
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${waterImg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"QUESTIONS D’EAU…"}
          </h1>
          <p className="mt-4 text-white">
            … ou la réponse aux questions que vous vous posez sur notre eau
          </p>
        </section>
        <div className="bg-neutral-200">
          <div className="container mx-auto md:px-40 sm:px-40">
            <Accordion type="single" collapsible className="w-full pt-5 ">
              <AccordionItem value="item-1">
                <AccordionTrigger className="font-bold text-black">
                  Quels volumes consommons-nous ?
                </AccordionTrigger>
                <AccordionContent>
                  La consommation d’eau, tous postes confondus (habitations,
                  piscines, espaces verts…), s’élève annuellement à Parly 2 à
                  quelque 580 000 m3, dont 71% pour notre seule consommation
                  domestique.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2">
                <AccordionTrigger className="font-bold text-black">
                  Quels coûts ?
                </AccordionTrigger>
                <AccordionContent>
                  Le coût moyen au m 3 d’eau potable consommée est de l’ordre de
                  6,19 € (facture octobre 2023). Les dépenses d’eau potable pour
                  l’ensemble de Parly 2, toutes résidences confondues, s’élèvent
                  ainsi à 2,1 millions d’€. Ce prix au m 3 se décompose en trois
                  postes : la distribution de l’eau (30%), le coût de la
                  collecte et du traitement des eaux usées (60%), ls organismes
                  publics (10%). <br />
                  Pour une famille qui consommerait de 120 m 3 d’eau –
                  consommation annuelle moyenne pour une famille de 4 personnes
                  – le coût est de 743 €, soit 62 €/mois. Une douche (50 litres)
                  coûte 31 centimes, un bain (120 litres) coûte 74 centimes, une
                  lessive (100 litres) coûte 62 centimes. <br />
                  En absence de compteurs individuels, la fourniture de
                  l&#39;eau froide et de l&#39;eau chaude sanitaires est imputée
                  dans les charges. Les coûts sont répartis, par résidences, en
                  fonction des tantièmes de charges de chacun.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3">
                <AccordionTrigger className="font-bold text-black">
                  Qui fournit l’eau au Chesnay-Rocquencourt ?
                </AccordionTrigger>
                <AccordionContent>
                  Notre fournisseur d’eau est Aquavesc, un établissement
                  territorial en charge de la production, du traitement et de la
                  distribution d’eau potable pour 32 communes des départements
                  des Hauts-de-Seine et des Yvelines, dont Le
                  Chesnay-Rocquencourt. Ses missions : captage de l’eau brute,
                  traitement et production d’eau potable, distribution à
                  l’usager…
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-4">
                <AccordionTrigger className="font-bold text-black">
                  D’où vient l’eau que nous buvons ?
                </AccordionTrigger>
                <AccordionContent>
                  L’eau brute provient de la nappe phréatique de
                  Croissy-sur-Seine. Cette nappe, insuffisamment alimentée de
                  façon naturelle, bénéficie d’une réalimentation artificielle à
                  partir d’eau de la Seine. L’eau est préalablement traitée par
                  voie physico-chimique puis par voie biologique. Elle est
                  ensuite réinfiltrée très lentement dans d’anciennes sablières
                  spécialement aménagées. Cette réalimentation permet de faire
                  face à l’augmentation des débits pompés et d’améliorer la
                  qualité de l’eau sur l’ensemble de la nappe. <br />
                  Onze forages de 30 à 60 mètres de profondeur permettent de
                  prélever les quantités nécessaires à tout moment. La station
                  de pompage de Bougival relève l’eau brute jusqu’aux bassins
                  des Deux Portes et de Louveciennes. L’eau acheminée par la
                  station est ensuite traitée à l’usine de Louveciennes.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-5">
                <AccordionTrigger className="font-bold text-black">
                  Quelle est le rôle de l’usine de Louveciennes ?
                </AccordionTrigger>
                <AccordionContent>
                  L’eau, qui arrive à la station de traitement d’eau potable de
                  Louveciennes, est naturellement riche en minéraux, et
                  particulièrement en calcium. A Louveciennes, l’eau suit
                  plusieurs traitements : tamisage et filtration (pour retenir
                  les impuretés, particules organiques et produits) et
                  filtration (pour retenir les impuretés chimiques),
                  décarbonatation (pour adoucir l’eau par élimination d’une
                  partie du calcaire), ozonation (pour détruire les germes et
                  virus par diffusion d‘ozone) et chloration (pour désinfecter à
                  l’aide de chlore). Cette eau potable est alors transportée
                  jusqu’à des réservoirs enterrés et des châteaux d’eau, où elle
                  est stockée avant sa distribution jusqu’aux robinets.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-6">
                <AccordionTrigger className="font-bold text-black">
                  Qui contrôle la qualité de notre eau ?
                </AccordionTrigger>
                <AccordionContent>
                  La chaîne de traitement poussée de l’usine de Louveciennes
                  permet de produire une eau présentant un niveau de sécurité
                  sanitaire élevé, assure l’élimination de la micropollution
                  (notamment les pesticides) et permet d’éliminer 50 % du
                  calcaire (calcium) en excès. L’eau distribuée présente, de
                  plus, de bonnes qualités organoleptiques (odeur, saveur).{" "}
                  <br />
                  La qualité de cette eau est régulièrement contrôlée par l’ARS
                  (Agence régionale de santé). Ces informations quant à la
                  qualité de l’eau sur la Commune du Chesnay sont disponibles
                  sur le site de l’ARS et sur le panneau d’affichage
                  administratif situé à l’entrée de la Mairie. <br />
                  Pour tout autre renseignement, vous pouvez consulter le site
                  internet d’Aquavesc. Pour plus de renseignements, contacter le
                  service d&#39;hygiène et de santé communales au 01 39 23 23
                  55.
                  <div className="flex justify-center mt-5">
                    <img src={img1} alt="" className="w-full rounded-lg " />
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-7">
                <AccordionTrigger className="font-bold text-black">
                  L’eau au Chesnay-Rocquencourt est dite « dure ». Qu’en est-il
                  ?
                </AccordionTrigger>
                <AccordionContent>
                  La dureté d’une eau ou son titre hydrotimétrique (TH) exprime
                  sa concentration en sels de calcium et de magnésium. La dureté
                  est liée à la nature des terrains traversés par une eau. Si
                  l’eau présente une forte concentration de ces sels minéraux,
                  on dit qu’elle est dure (c’est le cas des eaux provenant des
                  sols calcaires). Avec une dureté de 19,0 °f, on peut dire, en
                  effet, qu’au Chesnay-Rocquencourt l’eau est dure. Au-delà,
                  déterminer où se situe la frontière entre de l&#39;eau douce,
                  dure ou très dure, demeure assez subjectif.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-8">
                <AccordionTrigger className="font-bold text-black">
                  Comment interpréter ce chiffre ?
                </AccordionTrigger>
                <AccordionContent>
                  1°f signifie qu&#39;il y a 10 grammes de calcaire présents
                  dans 1000 litres ou 1 m 3  d&#39;eau. Pour une dureté
                  d&#39;eau relevée à 19°f et, avec toujours une consommation
                  annuelle moyenne pour une famille de 4 personnes de 120 m 3 ,
                  vous faites « entrer » 22,8 kg de calcaire chez vous.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-9">
                <AccordionTrigger className="font-bold text-black">
                  Une eau calcaire est-elle dangereuse pour notre santé ?
                </AccordionTrigger>
                <AccordionContent>
                  Une eau dure, par son apport en calcium et en magnésium, est
                  bonne pour la santé, mais elle accélère par contre
                  l’entartrage des conduites et réagit mal au savon. A
                  l’inverse, une eau trop douce a tendance à corroder les
                  canalisations. Contrairement aux idées reçues, la présence de
                  calcaire dans l&#39;eau n&#39;affecte en rien notre santé.
                  Notre corps n&#39;est pas une machine à laver, il ne
                  s&#39;entartre pas ! Bien au contraire, l&#39;eau calcaire est
                  riche en magnésium et en calcium, éléments indispensables à
                  notre organisme. <br />
                  Attention : si notre eau n’est pas dangereuse pour notre santé
                  personnelle, elle l’est, de façon non négligeable, pour celle
                  de nos appareils électro-ménagers.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-10">
                <AccordionTrigger className="font-bold text-black">
                  Comment éliminer le goût de chlore qu’a parfois l’eau du
                  robinet ?
                </AccordionTrigger>
                <AccordionContent>
                  Il suffit de placer l’eau dans une carafe quelques heures au
                  réfrigérateur, encore mieux avec une rondelle de citron !
                  Rappelons que la dose minime de chlore présente, sans aucun
                  impact sur la santé, est le meilleur moyen pour empêcher le
                  développement de germes dangereux.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-11">
                <AccordionTrigger className="font-bold text-black">
                  Que faire si l’eau du robinet est trouble ?
                </AccordionTrigger>
                <AccordionContent>
                  Suite à des travaux sur le réseau ou de retour d’une absence
                  prolongée, l’eau qui coule à votre robinet peut prendre une
                  couleur inhabituelle. Laissez-la couler quelques minutes pour
                  qu’elle reprenne son aspect habituel. Et si tel n’était pas le
                  cas, contactez Aquavesc.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-12">
                <AccordionTrigger className="font-bold text-black">
                  Quid de l’entretien ?
                </AccordionTrigger>
                <AccordionContent>
                  Un arrêt technique, d&#39;une semaine, de la distribution
                  d&#39;eau chaude est obligatoire une fois par an en période
                  estivale pour assurer la maintenance de l&#39;installation.
                  <div className="flex justify-center mt-5">
                    <img src={img2} alt="" className="w-48 rounded-lg " />
                  </div>
                  <p className="mt-2">
                    Par ailleurs, pour nous permettre d’éviter des consommations
                    d’eau inutiles et de conserver nos appareils en bon état, un
                    contrat d&#39;entretien de la robinetterie, inclus dans nos
                    charges est souscrit avec la société Ista-Aquagest. Les
                    prestations contractuelles comprennent : l&#39;entretien et
                    la réparation des robinetteries, mélangeurs, robinets
                    d&#39;arrêt, mitigeurs mécaniques, mécanisme interne de
                    chasse d&#39;eau ; le remplacement de pièces détachées ou
                    des appareils complets hors d&#39;usage par des appareils de
                    même marque ou équivalents (mitigeurs thermostatiques ainsi
                    que les bombes et siphons sont hors contrat. Demandez à
                    votre intendant de vous inscrire pour une visite de
                    contrôle.
                  </p>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqHeroSection;
